// SSR-compatible Amenities component
import React from "react";
import ImageItem from "../../app/_shims/ImageItem";

const AmenitiesItem = ({ amenitiesgrid }) => {
  return (
    <>
      <div className="amenities_container">
        <ul className="nh_icon_grid_ul">
          {amenitiesgrid &&
            amenitiesgrid.map((item, index) => {
              return (
                <li key={index} className="grid_item">
                  <ImageItem
                    centered
                    source={item.icon}
                    title="Neighborhood Amenities"
                    alt="Neighborhood Amenities"
                    width="60"
                    height="60"
                    loading="lazy"
                  />
                  <div
                    className="ui small center aligned header"
                    style={{
                      color: "rgb(15, 20, 67)",
                      letterSpacing: "0.3px",
                      margin: "5px 7px",
                    }}
                  >
                    {item.title}
                  </div>
                  <p>{item.score}</p>
                </li>
              );
            })}
        </ul>
      </div>
    </>
  );
};

export default AmenitiesItem;
